import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-outgoing-item-status',
  templateUrl: './outgoing-item-status.component.html',
  styleUrls: ['./outgoing-item-status.component.scss']
})
export class OutgoingItemStatusComponent implements OnInit {
  @Input() sent: any;
  @Input() sentInfo: string;

  constructor() { }

  ngOnInit(): void {
  }

}
